import React, { useState, useEffect } from 'react';
import { MainNavbar } from '../../common/navbar';
import BanList from './BanList';
import styles from './viewBans.module.css';
import { Input, Tooltip } from '@mantine/core';
import BanDetails from './banDetails';
import { useFetch } from '../../../hooks';
import config from '../../../utils/config';

export const ViewBans = (props) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [isBanDetailVisible, setIsBanDetailVisible] = useState(false);
  const [banDetails, setBanDetails] = useState({});
  const [additionalBans, setAdditionalBans] = useState([]);
  const [currentBanDetails, setCurrentBanDetails] = useState(null);
  const handleSearchTermChange = (input) => {
    setSearchTerm(input.target.value);
  };

  const getUrl = () =>
    currentBanDetails
      ? `${config.BACKEND_HOST}/api/v1/bans/${currentBanDetails.id}`
      : null;

  const getUrl2 = () =>
    currentBanDetails
      ? `${config.BACKEND_HOST}/api/v1/bans/${currentBanDetails.bannedId}?steamId=true`
      : null;

  const { data: results, loading, error } = useFetch(getUrl());
  const [pageNumber, setPageNumber] = useState(1);
  const [totalNumberOfBans, setTotalNumberOfBans] = useState(1);

  const {
    data: steamData,
    loading: steamIsLoading,
    error: steamError,
  } = useFetch(getUrl2());

  useEffect(() => {
    setIsBanDetailVisible(false);
    if (results && steamData) {
      setBanDetails(results);
      setAdditionalBans(steamData.bans);
      setIsBanDetailVisible(true);
    }
  }, [currentBanDetails, results, steamData]);

  useEffect(() => {
    if (steamData?.bans) {
      setIsBanDetailVisible(true);
    }
  }, [steamData?.bans]);

  const renderBanDetails = async (banDetails) => {
    const [extendedBanDetails, otherBans] = await Promise.all([
      fetch(`${config.BACKEND_HOST}/api/v1/bans/${banDetails.id}`),
      fetch(
        `${config.BACKEND_HOST}/api/v1/bans/${banDetails.bannedId}?steamId=true`
      ),
    ]);
    const jsoNBody = await extendedBanDetails.json();
    const otherBansRes = await otherBans.json();
    const correctOtherBans = otherBansRes.bans.filter(
      (currentBan) => currentBan.id !== banDetails.id
    );

    setAdditionalBans(correctOtherBans);
    setBanDetails(jsoNBody);
    setIsBanDetailVisible(true);
  };

  const rightSection = (
    <Tooltip
      label="We do not send spam"
      position="top"
      placement="end"
      style={{ 'z-index': '1' }}
    >
      {/* <AlertCircle size={16} style={{ display: "block", opacity: 0.5 }} /> */}
    </Tooltip>
  );

  return (
    <div>
      <div className={styles.page}>
        <MainNavbar
          pageNumber={pageNumber}
          setPageNumber={setPageNumber}
          totalNumberOfBans={totalNumberOfBans}
        />
        <div className={styles.body}>
          <Input
            placeholder="Search For SteamID"
            rightSection={rightSection}
            style={{ 'z-index': '1' }}
            className={styles.searchBar}
            onChange={handleSearchTermChange}
          />
          ;
          {isBanDetailVisible && (
            <BanDetails
              banDetails={banDetails}
              setIsBanDetailVisible={setIsBanDetailVisible}
              additionalBans={additionalBans}
              isLoading={loading || steamIsLoading}
            />
          )}
          <div className={styles.banList}>
            <BanList
              searchTerm={searchTerm}
              renderBanDetails={renderBanDetails}
              setCurrentBanDetails={setCurrentBanDetails}
              pageNumber={pageNumber}
              setTotalNumberOfBans={setTotalNumberOfBans}
              steamIsLoading={loading || steamIsLoading}
              setIsBanDetailVisible={setIsBanDetailVisible}
            />
          </div>
          <div className={styles.footerSpacer} />
        </div>
      </div>
    </div>
  );
};

export default ViewBans;
